'use client';

import classNames from 'classnames';
import { MedicareApiPlan } from 'types/api';
import { findPlanType } from 'utils/planDetails';
import styles from '../PlanCard.module.scss';
import ShieldIcon from 'components/icons/ShieldIcon';
import PillIcon from 'components/icons/PillIcon';

interface PlanTypeBannerProps {
  plan: MedicareApiPlan;
  planColor: string;
}

export default function PlanTypeBanner({
  plan,
  planColor,
}: PlanTypeBannerProps) {
  const planTypeLabel = plan.type !== 'gap' ? plan.network : plan.medicare_id;

  const hasMedicalCoverage = ['mapd', 'ma', 'gap'];
  const hasRxCoverage = ['mapd', 'pdp'];

  const showMedicalIcon = hasMedicalCoverage.includes(plan.type);
  const showDrugIcon = hasRxCoverage.includes(plan.type);

  const bannerClass = classNames(styles.planTypeBanner);

  const pillIconColor = plan.type === 'pdp' ? 'var(--peach-600)' : planColor;

  return (
    <div className={bannerClass}>
      <div className={styles.bannerContent}>
        <div>
          {showMedicalIcon && <ShieldIcon color={planColor} />}
          {showDrugIcon && <PillIcon color={pillIconColor} />}
        </div>
        <h3>{findPlanType(plan.type)}</h3>
        <span className={styles.planTypeBadge}>{planTypeLabel}</span>
      </div>
    </div>
  );
}
